module.exports = __webpack_public_path__ + "static/14-2bb24c243e188b8c9e0a00fd87b0e1fe.jpg";